// extracted by mini-css-extract-plugin
export default {"subcategoriesRow":"j_6","subcategoryColumn":"j_7","articleLink":"j_8","articleCoverImage":"j_9","articleTitle":"j_bb"};